import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    error: false,
    visits: false,
    uniqueVisits: false,
    totalViews: false,
    viewsPerDay: false,
    mostViewedClips: false,
    csvDownload: false
};

const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.STATISTICS_VISITS_SUCCESS:
            return updateObject(state, { visits: action.data });
        case actionTypes.STATISTICS_UNIQUE_VISITS_SUCCESS:
            return updateObject(state, { uniqueVisits: action.data });
        case actionTypes.STATISTICS_TOTAL_VIEWS_SUCCESS:
            return updateObject(state, { totalViews: action.data });
        case actionTypes.STATISTICS_VIEWS_PER_DAY_SUCCESS:
            return updateObject(state, { viewsPerDay: action.data });
        case actionTypes.STATISTICS_MOST_VIEWED_CLIPS_SUCCESS:
            return updateObject(state, { mostViewedClips: action.data });
            case actionTypes.STATISTICS_CSV_DOWNLOAD_SUCCESS:
            return updateObject(state, { csvDownload: action.data });
        default: 
            return state;
    }
}

export default reducer;
